export const CONTACT_US_FORM_NAME = 'CONTACT_US_FORM';

export const ContactUsFormField = {
	userName: 'userName',
	organizationName: 'organizationName',
	phone: 'phone',
	email: 'email',
	message: 'message',
	recaptchaResponse: 'recaptchaResponse',
} as const;
